import {create} from "zustand";

const useAppConfig = create((set) => ({
    apiUrl: process.env.REACT_APP_API_URL,
}));
export default useAppConfig;